class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="text"]');
    this.predictiveSearchResults = document.querySelector('#predictive-search');
    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
      var input_length = this.input.value.length;
      if(input_length>0){
        document.querySelectorAll('.search-Button').forEach(function(SeachButtons){
          SeachButtons.disabled = false;
        });
      }else{
        document.querySelectorAll('.search-Button').forEach(function(SeachButtons){
          SeachButtons.disabled = true;
        });
      } 
    }, 300).bind(this));
  }
  onChange() {
    const searchTerm = this.input.value.trim();
    if (!searchTerm.length) {
      this.close();
      return;
    }
    this.getSearchResults(searchTerm);
  }
  getSearchResults(searchTerm) {
    fetch(`/search/suggest?q=${searchTerm}&resources[type]=product&resources[limit]=5&section_id=predictive-search`)
    .then((response) => {
      if (!response.ok) {
        var error = new Error(response.status);
        this.close();
        throw error;
      }
      return response.text();
    })
    .then((text) => {
      const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
      this.predictiveSearchResults.innerHTML = resultsMarkup;
      this.open();
      if(typeof quickAddButton == 'function'){
        quickAddButton();
      }
      if(document.getElementById('SearchValue')){
        document.getElementById('SearchValue').value = searchTerm;
      }

        var swiper = new Swiper(".search-slider.swiper", {
          slidesPerView: "auto",
        });
      
        document.querySelectorAll('.product-link.swipper').forEach((el, index) => {
          new Swiper(el, {
            slidesPerView: 'auto',
            spaceBetween: 10,
            allowTouchMove: false,
            slidesPerGroup: 1, 
            navigation: {
              nextEl: el.querySelector(".swiper-button-next"),
              prevEl: el.querySelector(".swiper-button-prev"),
            },
          });
        });
      
    })
    .catch((error) => {
      this.close();
      throw error;
    });
  }
  open() {
    this.predictiveSearchResults.style.display = 'block';
    document.querySelector(".outer").style.visibility = 'hidden';
    document.querySelector(".outer").style.opacity = 0;
  }
  close() {
    this.predictiveSearchResults.style.display = 'none';
    document.querySelector(".outer").style.visibility = 'visible';
    document.querySelector(".outer").style.opacity = 1;
  }
  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}
customElements.define('predictive-search', PredictiveSearch);
document.querySelectorAll('.menu-burdger,.close-menu').forEach(function(menuBurger){
  menuBurger.addEventListener('click',function(e){
    document.querySelector('body').classList.toggle('open-menu');
    document.querySelector('body').classList.remove('open-drawer','open-search','open-sort','open-filter');    
  });
});
document.querySelectorAll('.mobile-search').forEach(function(searchButton){
  searchButton.addEventListener('click',function(e){
    document.querySelector('body').classList.toggle('open-search');
    document.querySelector('body').classList.remove('open-drawer','open-menu','open-sort','open-filter');
    document.querySelector(".mobile-serachbox #Search").focus();
  });
});
document.querySelector('.overlay-box').addEventListener('click',function(e){
  document.querySelector('body').classList.remove('open-menu');
  document.querySelector('body').classList.remove('search-open');
  document.querySelector('body').classList.remove('open-size-chart');
  const closeBtn = document.querySelector('.fixed-quick .quick-close');
  if (closeBtn) {
    closeBtn.click();
  }
});
if(document.querySelectorAll('.variant-grid')){
  function quickAddButton(){
    document.querySelectorAll('.variant-grid').forEach(function(sizeList){
      sizeList.addEventListener('click',function(e){
        e.preventDefault();
        let variant_id = sizeList.dataset.id;
        let error_grid_outer = sizeList.closest('.snippet-product-grid');
        let error_grid = error_grid_outer.querySelector('.grid-error');
        let formData = {
          'items': [{
            'id': variant_id,
            'quantity': 1
          }]
        };
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData),
        })
        .then((response) => response.json())
        .then((data) => {
          if(data.status == 422)
          {
            error_grid.innerHTML = data.description;
            setTimeout(function(e){
              error_grid.innerHTML = '';
            },2000);
          }else{          
            if(document.location.href.indexOf('/cart') > -1) {
              window.location.href = "/cart";
            }else{
              if(typeof load_cart == 'function'){
                load_cart();
                setTimeout(function(e){
                  document.querySelector('body').classList.add('open-drawer');
                },500);
              }else{
                window.location.href = "/cart";
              }          
            }
            const url = '/cart.js';
            fetch(url)
            .then((resp) => resp.json())
            .then(function(data) {
              var cart_count = data.item_count;
              if(cart_count>0){
                document.querySelector('.cart-count').innerHTML = cart_count;
              }else{
                document.querySelector('.cart-count').innerHTML = '';
              }
            })
            .catch(function(error) {
              console.log(error);
            })
          }
        })
        .catch((error) => {
          console.error(error);
        });
      });
    });    
//     document.querySelectorAll('.quick-add').forEach(function(quickAdd){
//       quickAdd.onclick = function(){
//         document.querySelectorAll('.snippet-product-grid').forEach(function(everyProduct){       
//           everyProduct.classList.remove('active-quick');
//         });
//         let gridimgbox = quickAdd.closest('.snippet-product-grid');      
//         gridimgbox.classList.add('active-quick');
//       };
//     });
  }
  quickAddButton();
}

if (document.querySelector('.nav-arrow')) {
  document.querySelectorAll('.nav-arrow').forEach(function (navArrow) {
    navArrow.addEventListener('click', function (e) {
      const li = navArrow.closest('li');
      const siblings = li.parentElement.querySelectorAll('li.active'); 
      siblings.forEach(function (sib) {
        if (sib !== li) {
          sib.classList.remove('active');
        }
      });
      li.classList.toggle('active'); 
    });
  });
}

// if (document.querySelector('.list-menu')) {
//   document.querySelectorAll('.list-menu > li, .searchlist, .header-icons .menu-level-1').forEach(function(navList) {
//     navList.addEventListener('mouseover', function() {
//       navList.classList.add('active');
//       document.querySelector('.header-row')?.classList.add('active-hover');
//       document.body.classList.add('show-overlay');
//     });
//     navList.addEventListener('mouseout', function() {
//       navList.classList.remove('active');
//       document.querySelector('.header-row')?.classList.remove('active-hover');
//       document.body.classList.remove('show-overlay');
//     });
//   });
// }
if (document.querySelector('.list-menu')) {
  document.querySelectorAll('.header-icons .menu-level-1').forEach(function(navList) {
    navList.addEventListener('mouseover', function() {
      navList.classList.add('active');
      document.querySelector('.header-row')?.classList.add('active-hover');
      document.body.classList.add('show-overlay');
    });
    navList.addEventListener('mouseout', function() {
      navList.classList.remove('active');
      document.querySelector('.header-row')?.classList.remove('active-hover');
      document.body.classList.remove('show-overlay');
    });
  });
}

if (window.innerWidth > 991) {
  if (document.querySelector('.list-menu')) {
    document.querySelectorAll('.searchlist').forEach(function(navList) {
      navList.addEventListener('mouseover', function() {
        navList.classList.add('active');
        document.querySelector('.header-row')?.classList.add('active-hover');
        document.body.classList.add('show-overlay');
      });
      navList.addEventListener('mouseout', function() {
        navList.classList.remove('active');
        document.querySelector('.header-row')?.classList.remove('active-hover');
        document.body.classList.remove('show-overlay');
      });
    });
  }
}

if (document.querySelector('.menu-level-3 a')) {
  document.querySelectorAll('.menu-level-3 a').forEach(function(navList) {
    navList.addEventListener('mouseover', function() {
      let liParent = navList.closest('li');
      if (liParent) liParent.classList.add('active');
      let subMenuParent = navList.closest('.sub-menu');
      if (subMenuParent) subMenuParent.classList.add('active-hover');
      document.querySelectorAll('.menu-level-3 a').forEach(function(link) {
        link.classList.remove('direct-hover');
      });
      navList.classList.add('direct-hover');
    });
    navList.addEventListener('mouseout', function() {
      let liParent = navList.closest('li');
      if (liParent) liParent.classList.remove('active');

      let subMenuParent = navList.closest('.sub-menu');
      if (subMenuParent) subMenuParent.classList.remove('active-hover');
    });
  });
}
if (document.querySelector('.shop-by-size .menu-level-3 a')) {
  document.querySelectorAll('.shop-by-size .menu-level-3 a').forEach(function(navList) {
    navList.addEventListener('mouseover', function() {
      let liParent = navList.closest('li');
      if (liParent) liParent.classList.add('active');
      let subMenuParent = navList.closest('.sub-menu');
      if (subMenuParent) subMenuParent.classList.add('active-hover');
      navList.classList.add('direct-hover');
    });
    navList.addEventListener('mouseout', function() {
      let liParent = navList.closest('li');
      if (liParent) liParent.classList.remove('active');
      let subMenuParent = navList.closest('.sub-menu');
      if (subMenuParent) subMenuParent.classList.remove('active-hover');
      navList.classList.remove('direct-hover');
    });
  });
}
if (document.querySelector('.our-picks .menu-level-3 a')) {
  document.querySelectorAll('.our-picks .menu-level-3 a').forEach(function(navList) {
    navList.addEventListener('mouseover', function() {
      let liParent = navList.closest('li');
      if (liParent) liParent.classList.add('active');
      let subMenuParent = navList.closest('.sub-menu');
      if (subMenuParent) subMenuParent.classList.add('active-hover');
      navList.classList.add('direct-hover');
    });
    navList.addEventListener('mouseout', function() {
      let liParent = navList.closest('li');
      if (liParent) liParent.classList.remove('active');
      let subMenuParent = navList.closest('.sub-menu');
      if (subMenuParent) subMenuParent.classList.remove('active-hover');
      navList.classList.remove('direct-hover');
    });
  });
}
if (document.querySelector('.shop .index-1 .menu-level-3 a')) {
  document.querySelectorAll('.shop .index-1 .menu-level-3 a').forEach(function(navList) {
    navList.addEventListener('mouseover', function() {
      let liParent = navList.closest('li');
      if (liParent) liParent.classList.add('active');
      let subMenuParent = navList.closest('.sub-menu');
      if (subMenuParent) subMenuParent.classList.add('active-hover');
      navList.classList.add('direct-hover');
    });
    navList.addEventListener('mouseout', function() {
      let liParent = navList.closest('li');
      if (liParent) liParent.classList.remove('active');
      let subMenuParent = navList.closest('.sub-menu');
      if (subMenuParent) subMenuParent.classList.remove('active-hover');
      navList.classList.remove('direct-hover');
    });
  });
}

// if (document.querySelector('.menu-level-3 a')) {
//   document.querySelectorAll('.menu-level-3 a').forEach(function (navList) {
//     navList.addEventListener('mouseover', function () {
//       let liParent = navList.closest('li');
//       let allLis = document.querySelectorAll('.menu-level-1.active li');
//       allLis.forEach(function (li) {
//         let anchor = li.querySelector('a.direct-hover');
//         if (anchor && anchor !== navList) {
//           anchor.classList.remove('direct-hover');
//         }
//       });
//       if (liParent) liParent.classList.add('active');
//       let subMenuParent = navList.closest('.sub-menu');
//       if (subMenuParent) subMenuParent.classList.add('active-hover');
//       navList.classList.add('direct-hover');
//     });
//     navList.addEventListener('mouseout', function () {
//       let liParent = navList.closest('li');
//       if (liParent) liParent.classList.remove('active');

//       let subMenuParent = navList.closest('.sub-menu');
//       if (subMenuParent) subMenuParent.classList.remove('active-hover');

//       navList.classList.remove('direct-hover');
//     });

//   });
// }

// document.querySelectorAll('.right-side > li').forEach(function (el) {
//   el.addEventListener('mouseout', function () {
//     const megaMenu = el.closest('.mega-menu');
//     if (!megaMenu) return;
//     megaMenu.querySelectorAll('.menu-level-1.active li.active').forEach(function (item) {
//       item.classList.remove('active');
//     });
//     megaMenu.querySelectorAll('.menu-level-1.active li a.direct-hover').forEach(function (link) {
//       link.classList.remove('direct-hover');
//     });
//     const mainImg = megaMenu.querySelector('.main-mega-img.main');
//     if (mainImg) {
//       mainImg.classList.add('active');
//     }
//   });
// });




document.querySelectorAll('.navmobile-dropdown , .fixed-quick .main-quick-shop .inner-qs').forEach(function(navDropdown) {
  navDropdown.addEventListener('scroll', function () {
    if (navDropdown.scrollTop > 0) {
      navDropdown.classList.add('show-box-shadow');
    } else {
      navDropdown.classList.remove('show-box-shadow');
    }
  });
});

document.querySelectorAll('.main-filter .filter-box').forEach(function(navDropdown) {
  navDropdown.addEventListener('scroll', function () {
    if (navDropdown.scrollTop > 0) {
      navDropdown.classList.add('show-box-shadow');
    } else {
      navDropdown.classList.remove('show-box-shadow');
    }
  });
});


document.onkeydown = function(evt) {
  evt = evt || window.event;
  var isEscape = false;
  if ("key" in evt) {
    isEscape = (evt.key === "Escape" || evt.key === "Esc");
  } else {
    isEscape = (evt.keyCode === 27);
  }
  if (isEscape) {
    document.querySelector('body').classList.remove('open-filter','open-sort','open-drawer','open-menu','open-search');
  }
};


function getScrollbarWidth() {
  return window.innerWidth - document.documentElement.clientWidth;
}

document.documentElement.style.setProperty('--scrollbar-width', getScrollbarWidth() + 'px');




document.addEventListener('keydown', function (e) {
  if (e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27) {
    const activeItems = document.querySelectorAll('.media-grid .media-grid-column.active');
    activeItems.forEach(function (el) {
      el.classList.remove('active');
    });
    if (document.body.classList.contains('search-open')) {
      document.body.classList.remove('search-open');
    }
  }
});


document.querySelectorAll('.close-popup').forEach(function(button) {
  button.addEventListener('click', function() {
    document.body.classList.remove('wishlist-added');
  });
});

var wc_product = '';
var wcProductID = '';
var wcVariantID = '';
window.$wc_wishlist_addToWishlist = (self) => {
  wc_product = self.closest('.th_prd_wl_btn, .th_wl_col_btn').getAttribute('data-product-handle');
  wcVariantID = self.closest('.th_prd_wl_btn, .th_wl_col_btn').getAttribute('data-variant_id');
  wcProductID = self.closest('.th_prd_wl_btn, .th_wl_col_btn').getAttribute('data-product_id');
  console.log('self', self);
  return 0;
}
window.$th_wishlistAdd_callback_successMessage = (message) => {
  console.log('wc_product', wc_product);
  console.log('wcVariantID', wcVariantID);
  console.log('wcProductID', wcProductID);
  console.log('message', message);
  if(message.includes('added')){
    renderWishlistPopup(wc_product, wcProductID, wcVariantID);
    document.querySelector('.wishlist-popup').style.display = 'block';
    document.body.classList.remove("open-quick-view");
  }
}
async function renderWishlistPopup(productHandle, productId, variantId) {
  try {
    const res = await fetch(`/products/${productHandle}.js`, { credentials: 'same-origin' });
    if (!res.ok) throw new Error('Product JSON not found');
    const p = await res.json();

    // 1) Validate product/variant
    if (String(p.id) !== String(productId)) {
      console.warn('Product ID mismatch', { expected: productId, got: p.id });
      // continue anyway, but you can `return` if you want strict match
    }
    const variant = (p.variants || []).find(v => String(v.id) === String(variantId));
    if (!variant) {
      console.warn('Variant not found for id', variantId);
      return;
    }

    // // 2) Helpers
    // const money = (cents) => {
    //   // Prefer Shopify.formatMoney if present
    //   if (window.Shopify && typeof Shopify.formatMoney === 'function') {
    //     return Shopify.formatMoney(cents, window.theme && theme.moneyFormat ? theme.moneyFormat : '{{amount_with_comma_separator}}');
    //   }
    //   // Fallback
    //   const v = (Number(cents) / 100);
    //   return v.toLocaleString(undefined, { style: 'currency', currency: (window.Shopify && Shopify.currency) || 'USD' });
    // };

    Shopify.formatMoney = function(cents, format) {
      if (typeof cents == 'string') {
      cents = cents.replace('.', '');
      }
      var value = '';
      var placeholderRegex = /{{\s*(\w+)\s*}}/;
      var formatString = (format || this.money_format);
      function defaultOption(opt, def) {
          return (typeof opt == 'undefined' ? def : opt);
      }
      function formatWithDelimiters(number, precision, thousands, decimal) {
          precision = defaultOption(precision, 2);
          thousands = defaultOption(thousands, ',');
          decimal = defaultOption(decimal, '.');
          if (isNaN(number) || number == null) {
              return 0;
          }
          number = (number / 100.0).toFixed(precision);
          var parts = number.split('.'),
              dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
              cents = parts[1] ? (decimal + parts[1]) : '';
          return dollars + cents;
      }
      switch (formatString.match(placeholderRegex)[1]) {
          case 'amount':
              value = formatWithDelimiters(cents, 2);
              break;
          case 'amount_no_decimals':
              value = formatWithDelimiters(cents, 0);
              break;
          case 'amount_with_comma_separator':
              value = formatWithDelimiters(cents, 2, '.', ',');
              break;
          case 'amount_no_decimals_with_comma_separator':
              value = formatWithDelimiters(cents, 0, '.', ',');
              break;
      }
      return formatString.replace(placeholderRegex, value);
    };

    const ensureHttps = (src) => {
      if (!src) return '';
      if (src.startsWith('//')) return 'https:' + src;
      if (src.startsWith('http')) return src;
      return src;
    };

    // 3) Figure out image (variant featured image → product featured_image → first image)
    let imageSrc = '';
    // Some themes return variant.featured_image as object OR string OR null
    if (variant.featured_image) {
      imageSrc = typeof variant.featured_image === 'string'
        ? variant.featured_image
        : (variant.featured_image.src || '');
    }
    if (!imageSrc) imageSrc = p.featured_image || (p.images && p.images[0]) || '';
    imageSrc = ensureHttps(imageSrc);

    // 4) Map selected options by name
    // product.options = [{ name: 'Size', position: 1, values: [...] }, ...]
    // variant.option1/2/3 hold the selected values
    const optionMap = {};
    (p.options || []).forEach((opt, idx) => {
      const key = 'option' + (idx + 1);
      const value = variant[key];
      if (opt && opt.name && value && value !== 'Default Title') {
        optionMap[opt.name] = value;
      }
    });

    // If you specifically want to show "Size" and "Color" blocks only when present:
    const sizeValue  = optionMap['Size']  || optionMap['size']  || '';
    const colorValue = optionMap['Color'] || optionMap['colour'] || optionMap['color'] || '';

    // 5) Build HTML
    const html = `
        <div class="wraper">
          <div class="wishlist-p-top">
            <h4>ADDED TO WISHLIST</h4>
            <div class="close-popup"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M4.55806 4.55806C4.80214 4.31398 5.19786 4.31398 5.44194 4.55806L10 9.11612L14.5581 4.55806C14.8021 4.31398 15.1979 4.31398 15.4419 4.55806C15.686 4.80214 15.686 5.19786 15.4419 5.44194L10.8839 10L15.4419 14.5581C15.686 14.8021 15.686 15.1979 15.4419 15.4419C15.1979 15.686 14.8021 15.686 14.5581 15.4419L10 10.8839L5.44194 15.4419C5.19786 15.686 4.80214 15.686 4.55806 15.4419C4.31398 15.1979 4.31398 14.8021 4.55806 14.5581L9.11612 10L4.55806 5.44194C4.31398 5.19786 4.31398 4.80214 4.55806 4.55806Z" fill="#1C1C1C"/></svg></div>
          </div>
          <div class="wishlist-item">
            <div class="media">
              <a href="${p.url}"><img src="${imageSrc}" alt="${p.title}" width="120" height="120" loading="lazy" class="img" /></a>
            </div>
            <div class="info">
              <div class="title-wrapper">
                <h6>${p.title}</h6>
                <div class="price">${Shopify.formatMoney(variant.price)}</div>
              </div>
              ${sizeValue ? `<div class="size option">Size: ${sizeValue}</div>` : '' }
              ${colorValue ? `<div class="color option">Color: ${colorValue}</div>` : '' }
            </div>
          </div>
          <div class="wishlist-btn"><a href="/pages/wishlist" class="btn secondary">VIEW WISHLIST</a></div>
        </div>`;
      // <div class="wishlist-item">
      //   <div class="media">
      //     <a href="${p.url}">
      //       <img src="${imageSrc}" alt="${p.title}" width="120" height="120" loading="lazy" class="img" />
      //     </a>
      //   </div>
      //   <div class="info">
      //     <div class="title-wrapper">
      //       <h6>${p.title}</h6>
      //       <div class="price">${money(variant.price)}</div>
      //     </div>

      //     ${sizeValue ? `<div class="size option">Size: ${sizeValue}</div>` : '' }
      //     ${colorValue ? `<div class="color option">Color: ${colorValue}</div>` : '' }

      //     ${(!sizeValue && !colorValue)
      //       ? Object.keys(optionMap).map(name => `<div class="option">${name}: ${optionMap[name]}</div>`).join('')
      //       : ''}

      //     <div class="wishlist-btn">
      //       <!-- example remove button wired to your remover -->
      //       <button type="button"
      //         onclick="window.$wc_wishlist_removeItem && $wc_wishlist_removeItem(${p.id}, ${variant.id});">
      //         Remove
      //       </button>
      //     </div>
      //   </div>
      // </div>
    // 6) Inject into your popup (adjust selectors as needed)
    const popup = document.querySelector('.wishlist-popup');
    popup.innerHTML = '';
    if (popup) {
      const container = popup.querySelector('.wishlist-grid') || popup;
      const wrapper = document.createElement('div');
      wrapper.innerHTML = html.trim();
      container.prepend(wrapper.firstElementChild);
      popup.style.display = 'block';
      setTimeout(() => {
        popup.innerHTML = '';
      }, 5000);
    } else {
      // Fallback: append near body if popup not found
      const fallback = document.createElement('div');
      fallback.className = 'wishlist-popup';
      fallback.innerHTML = `<div class="wishlist-grid">${html}</div>`;
      document.body.appendChild(fallback);
    }

  } catch (e) {
    console.error('Wishlist popup render error:', e);
  }
}


document.addEventListener('click', function(e) {
  const closeBtn = e.target.closest('.wishlist-popup .close-popup');
  if (closeBtn) {
    document.querySelector('.wishlist-popup').style.display = 'none';
  }
});

document.addEventListener("click", (e) => {
  const el = e.target.closest(".fixed-quick .wishlist");
  if (!el) return;

  el.classList.add("pressed");
  setTimeout(() => {
    el.classList.remove("pressed");
  }, 2000);
});


document.addEventListener("DOMContentLoaded", function() {
  const soldOutBtns = document.querySelectorAll(".quick-add-btn .sold-out");

  soldOutBtns.forEach(function(btn) {
    btn.addEventListener("click", function() {
      localStorage.setItem("KlaviyoOpen", "true");
    });
  });
});
document.addEventListener("DOMContentLoaded", function() {
  if (localStorage.getItem("KlaviyoOpen") === "true") {
    setTimeout(function() {
      const soldOutBtn = document.querySelector(".snippet-addto-cart .sold-out-btn");
      if (soldOutBtn) {
        soldOutBtn.click();
        localStorage.removeItem("KlaviyoOpen");
      }
    }, 1000);
  }
});



const checkForm = setInterval(() => {
  const lastFormRow = document.querySelector(".needsclick div[data-testid='form-row'] button");
  if (lastFormRow) {
    lastFormRow.addEventListener("click", () => {
      alert("click");
    });
    clearInterval(checkForm); // stop checking once found
  }
}, 500); // check every 0.5s